var OrientationMode = (function () {
    function OrientationMode() {
    }
    return OrientationMode;
}());
export { OrientationMode };
/**
 *
 */
OrientationMode.DEFAULT = "default";
/**
 *
 */
OrientationMode.CAMERA_PLANE = "cameraPlane";
/**
 *
 */
OrientationMode.CAMERA_POSITION = "cameraPosition";



// WEBPACK FOOTER //
// ../dist/lib/base/OrientationMode.js